import { Extension } from '@tiptap/core';

/*
 * Once the caret is in the document, Tab is content and never navigation.
 *
 * The list extensions bind Tab to indenting the item under the caret. When there
 * is nothing to indent into — the first item of a list, an item with no sibling
 * above it — every one of them declines, the keydown reaches the browser, and
 * focus leaves the field for the block handle sitting above its first line.
 *
 * The priority is the whole trick: keymaps run highest priority first, so at 50
 * this one runs after every real handler and claims only what they refused. It
 * indents nothing itself. Escape is the deliberate way out, the exit WCAG asks
 * for from anything that swallows Tab; while the slash menu is open that menu
 * answers Escape first and this never sees it.
 */
export const KeyboardFocus = Extension.create({
  name: 'keyboardFocus',
  priority: 50,

  addKeyboardShortcuts() {
    return {
      Tab: () => true,
      'Shift-Tab': () => true,
      Escape: () => this.editor.commands.blur(),
    };
  },
});
